export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            了解香香漫画的故事与初心
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="shrink-0 w-full md:w-80 aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20illustration%20of%20a%20cozy%20library%20or%20reading%20space%20filled%20with%20colorful%20manga%20volumes%20on%20wooden%20shelves%2C%20soft%20natural%20light%20streaming%20through%20a%20window%2C%20cream%20and%20peach%20warm%20tones%2C%20peaceful%20atmosphere%2C%20clean%20minimal%20style%2C%20harmonious%20composition&width=1200&height=900&seq=about-brand-visual&orientation=landscape"
                  alt="香香漫画 - 关于我们，海量漫画免费在线阅读平台"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1">
                <h3 className="font-heading text-xl font-bold text-foreground-900">
                  香香漫画 —— 让每一个漫画迷都能找到属于自己的故事
                </h3>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  香香漫画网成立于对漫画的热爱之中，我们致力于为所有漫画爱好者打造一个安全、免费、便捷的在线阅读平台。无论是韩漫的精致画风、日漫的细腻叙事，还是国漫的创新活力，在这里你都能找到心仪的作品。我们采用下拉式追更技术，让你告别繁琐翻页，沉浸式享受每一部好看的漫画。香香漫画官网入口始终安全直达，不设任何付费门槛，让阅读回归纯粹。
                </p>
                <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                  我们深知每一位追更者的期待，因此团队坚持每日更新，确保热门漫画与最新连载同步上线。香香漫画网址不断优化阅读体验，覆盖电脑、平板、手机多端适配，让你随时随地畅享漫画世界。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}